<template>
  <div class="wifi-secret-container">
    <el-card class="container-card" shadow="hover">
      <el-form
    :inline="true"
    :model="searchForm"
    class="search-form"
    label-position="right"
    label-width="80px"
  >
    <div class="search-container">
      <el-form-item label="AID" size="small">
        <el-input
          v-model="searchForm.aid"
          placeholder="请输入 AID"
          clearable
        ></el-input>
      </el-form-item>

      <div class="btn-group">
        <el-button
          type="primary"
          size="small"
          @click="handleSearch"
          icon="el-icon-search"
          plain
        >
          搜索
        </el-button>
        <el-button
          size="small"
          @click="resetSearch"
          icon="el-icon-refresh"
          plain
        >
          重置
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="handleAdd"
          icon="el-icon-plus"
        >
          新增
        </el-button>
      </div>
    </div>
  </el-form>

      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)"
        class="data-table">
        <el-table-column
          prop="id"
          label="ID"
          width="80"
          align="center"
          header-align="center">
        </el-table-column>

        <el-table-column
          prop="aid"
          label="AID"
          width="300"
          align="center"
          show-overflow-tooltip
          header-align="center">
        </el-table-column>
        <el-table-column
          prop="clientid"
          label="客户端ID"
          width="300"
          align="center"
          show-overflow-tooltip
          header-align="center">
        </el-table-column>
        <el-table-column
          prop="secretkey"
          label="密钥"
          width="180"
          align="center"
          header-align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="180"
          align="center"
          header-align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime}}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="180"
          align="center"
          header-align="center">
          <template slot-scope="scope">
            {{ scope.row.updateTime }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="220"
          align="center"
          header-align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              plain>
              编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              plain>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background
          small>
        </el-pagination>
      </div>

      <!-- 新增/编辑对话框 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="50%"
        @close="handleDialogClose">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="100px"
          size="small">
          <el-form-item label="AID" prop="aid">
            <el-input v-model="form.aid" placeholder="请输入AID"></el-input>
          </el-form-item>
          <el-form-item label="客户端ID" prop="clientid">
            <el-input v-model="form.clientid" placeholder="请输入客户端ID"></el-input>
          </el-form-item>
          <el-form-item label="密钥" prop="secretkey">
            <el-input
              v-model="form.secretkey"
              placeholder="请输入密钥">
            </el-input>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {get, post} from '@/until/controlRequest'

export default {
  name: 'WifiSecretkey',
  data() {
    return {
      searchForm: {
        aid: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增密钥信息',
      form: {
        id: null,
        aid: '',
        clientid: '',
        secretkey: '',

      },
      rules: {
        aid: [
          {required: true, message: '请输入AID', trigger: 'blur'}
        ],
        clientid: [
          {required: true, message: '请输入客户端ID', trigger: 'blur'}
        ],
        secretkey: [
          {required: true, message: '请输入密钥', trigger: 'blur'}
        ],
        // kehu: [
        //   {required: true, message: '请输入客户标识', trigger: 'blur'}
        // ]
      }
    }
  },
  filters: {
    secretFilter(value) {
      if (!value) return ''
      if (value.length <= 4) {
        return '*'.repeat(value.length)
      }
      return value.substring(0, 2) + '*'.repeat(value.length - 4) + value.substring(value.length - 2)
    },
    formatDateTime(value) {
      if (!value) return ''
      return new Date(value).toLocaleString()
    }
  },
  created() {
    this.fetchPage()
  },
  methods: {
    fetchPage() {
      this.loading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.size,
        aid: this.searchForm.aid
      }

      get('/wifiSecretkey/page', params)
        .then(data => {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        })
        .catch(() => {
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchPage()
    },
    resetSearch() {
      this.searchForm = {
        aid: ''
      }
      this.handleSearch()
    },
    handleAdd() {
      this.dialogTitle = '新增密钥信息'
      this.form = {
        id: null,
        aid: '',
        clientid: '',
        secretkey: '',

      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑密钥信息'
      this.form = {
        id: row.id,
        aid: row.aid,
        clientid: row.clientid,
        secretkey: row.secretkey,

      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const api = this.form.id ? '/wifiSecretkey/update' : '/wifiSecretkey/save'
        post(api, this.form)
          .then(() => {
            this.$message.success(this.form.id ? '更新成功' : '新增成功')
            this.dialogVisible = false
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error(this.form.id ? '更新失败' : '新增失败')
          })
      })
    },
    handleDelete(row) {
      this.$confirm(`确定要删除 "${row.aid}" 的密钥信息吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(`/wifiSecretkey/delete/${row.id}`)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchPage()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchPage()
    }
  }
}
</script>

<style scoped>
.wifi-secret-container {
  padding: 20px;
}

.container-card {
  border-radius: 4px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
}

.search-form {
  background: #fff;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.search-container {
  display: flex;
  align-items: center;
  gap: 16px; /* 输入框和按钮间距 */
  flex-wrap: wrap; /* 小屏自动换行 */
}

.btn-group {
  display: flex;
  gap: 8px; /* 按钮间距 */
}

.el-form-item {
  margin-bottom: 0 !important; /* 让 inline 表单更紧凑 */
}

.el-input {
  min-width: 180px;
}

.form-buttons {
  display: flex;
  align-items: center;
}

.data-table {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/wifi/wifiSecretkeyConfig.vue